var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.accessToken
    ? _c(
        "section",
        { staticClass: "is-hidden-tablet", class: _vm.sectionClass },
        [
          _c("div", { staticClass: "section-content" }, [
            _c(
              "div",
              {
                staticClass: "has-text-centered",
                staticStyle: {
                  "margin-bottom": "1.2em",
                  "margin-top": "-.2em",
                },
              },
              [_vm._v(_vm._s(_vm.$t("menu.promo_code")))]
            ),
            _c(
              "div",
              {
                staticClass: "columns is-centered is-vcentered is-mobile",
                staticStyle: { "margin-bottom": "1.2em" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "button is-primary",
                    staticStyle: { margin: ".2em" },
                    on: { click: _vm.goPromoCode },
                  },
                  [_vm._v(_vm._s(_vm.$t("auth.enter_promo")))]
                ),
              ]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }